import styled from "styled-components"

export const DivTexte = styled.div`
width:80%;
@media (max-width: 769px) {
    width:100%;
  }`;
